import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

const Accounts = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default Accounts;
